import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Moon from "../packages/Moon";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from '@material-ui/core/Slider';
import Switch from "@material-ui/core/Switch";
import Cache from "Cache";

const styles = {
	root: {
		flexDirection: "row",
		flexWrap: "nowrap",
		alignItems: "center",
		justifyContent: "space-evenly"
	},
	inputs: {
		padding: "20px"
	},
	itemsPerRow: {
		marginBottom: "20px"
	},
	sliderBox: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexDirection: "column",
		marginBottom: "20px"
	},
	switchBox: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "nowrap",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: "20px"
	}
};

const classes = StyleSheet.create({});

class ZoomSettings extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			itemsPerRow: Moon.use(this.getItemsPerRowFromCache()),
			gridForceResize: Moon.use(),
			sliderZoomValue: Moon.use(this.getSliderZoomValueFromCache()),
			flatItems: Moon.use(this.getSwitchFromCache("flatItems")),
			imageMode: Moon.use(this.getSwitchFromCache("imageMode"))
		};

		this.itemsPerRow = this.state.itemsPerRow;
	}

	componentWillMount() {
		Moon.addStar(this);
	}

	getItemsPerRowFromCache() {
		const itemsPerRow = localStorage.getItem("itemsPerRow");
		if (itemsPerRow) return parseInt(itemsPerRow);
		return 4;
	}

	getSwitchFromCache(name) {
		const value = localStorage.getItem(name);
		if (value && value == "true") return true;
		return false;
	}

	getSliderZoomValueFromCache() {
		const zoom = localStorage.getItem("sliderZoomValue");
		if (zoom) return parseInt(zoom);
		return 100;
	}

	itemsPerRowOnChange = event => {
		let itemsPerRow = event.target.value;
		if (this.itemsPerRow == itemsPerRow) return;
		this.itemsPerRow = itemsPerRow;
		this.setState(
			{
				itemsPerRow: itemsPerRow,
				gridForceResize: true
			},
			() => {
				localStorage.setItem("itemsPerRow", itemsPerRow);
			}
		);
	};

	switchOnChange = name => event => {
		const checked = event.target.checked;
		this.setState({ [name]: checked }, () => {
			localStorage.setItem(name, checked);
		});
	};

	sliderOnChange = (event, value) => {
		this.setState({ sliderZoomValue: value }, () => {
			localStorage.setItem("sliderZoomValue", value);
		});
	};

	renderInputs() {
		return (
			<div style={styles.inputs}>
				<div style={styles.itemsPerRow}>
					<InputLabel htmlFor="itemsPerRowInput">
						Items per row
					</InputLabel>
					<Select
						value={this.state.itemsPerRow}
						onChange={this.itemsPerRowOnChange}
						fullWidth
						name="itemsPerRow"
						inputProps={{
							name: "itemsPerRowInput",
							id: "itemsPerRowInput"
						}}
					>
						<MenuItem value={2}>2</MenuItem>
						<MenuItem value={3}>3</MenuItem>
						<MenuItem value={4}>4</MenuItem>
						<MenuItem value={5}>5</MenuItem>
						<MenuItem value={6}>6</MenuItem>
					</Select>
				</div>

				<div style={styles.switchBox}>
					<InputLabel htmlFor="flatItems">Flat items</InputLabel>
					<Switch
						id="flatItems"
						color="primary"
						checked={this.state.flatItems}
						onChange={this.switchOnChange("flatItems")}
						value={this.state.flatItems}
					/>
				</div>
				<div style={styles.switchBox}>
					<InputLabel htmlFor="imageMode">Image mode</InputLabel>
					<Switch
						id="imageMode"
						color="primary"
						checked={this.state.imageMode}
						onChange={this.switchOnChange("imageMode")}
						value={this.state.imageMode}
					/>
				</div>
				<div style={styles.sliderBox}>
					<InputLabel htmlFor="GridSliderZoom">Grid zoom</InputLabel>
					<div style={{ height: "20px" }} />
					<Slider
						id="GridSliderZoom"
						value={this.state.sliderZoomValue}
						min={20}
						max={100}
						step={10}
						onChange={this.sliderOnChange}
					/>
				</div>
			</div>
		);
	}

	render() {
		if (this.props.open == false) return null;
		return <div style={styles.root}>{this.renderInputs()}</div>;
	}
}

// function valueReducer(rawValue, props, event) {
// 	const { disabled, max, min, step } = props;

// 	function roundToStep(number) {
// 		return Math.round(number / step) * step;
// 	}

// 	if (!disabled && step) {
// 		if (rawValue > min && rawValue < max) {
// 			if (rawValue === max - step) {
// 				// If moving the Slider using arrow keys and value is formerly an maximum edge value
// 				return roundToStep(rawValue + step / 2);
// 			}
// 			if (rawValue === min + step) {
// 				// Same for minimum edge value
// 				return roundToStep(rawValue - step / 2);
// 			}
// 			return roundToStep(rawValue);
// 		}
// 		return rawValue;
// 	}

// 	return defaultValueReducer(rawValue, props, event);
// }

export default ZoomSettings;
